import React, { useState, useEffect } from "react";
import dayjs from "dayjs";

const CurrentDateTime = () => {
  const [currentDateTime, setCurrentDateTime] = useState(dayjs());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(dayjs());
    }, 1000);

    return () => clearInterval(timer); // Dọn dẹp interval khi component unmount
  }, []);

  return (
    <div className="py-3">
      <div style={{ fontSize: 14, color: "#fff" }}>Thời gian: {currentDateTime.format("DD/MM/YYYY HH:mm:ss")}</div>
    </div>
  );
};

export default CurrentDateTime;
